import { PARTNER_COCKPIT_PREFILL_EMAIL_PARAM } from '@houzy/schemas/partner-cockpit/user-management';

import { isValidEmail } from './validators';

export type PrefillEmailLocation = { pathname: string; searchStr?: string; hash?: string };

// Left in the URL, the address would end up nested inside `redirect` on the way to /login and never reach the
// form. It leaves the target either way. `present` reports the parameter rather than the address, so a
// malformed one is stripped too.
export function splitPrefillEmail(location: PrefillEmailLocation): {
    target: string;
    prefillEmail?: string;
    present: boolean;
} {
    const params = new URLSearchParams(location.searchStr ?? '');
    const candidate = params.get(PARTNER_COCKPIT_PREFILL_EMAIL_PARAM);
    const present = params.has(PARTNER_COCKPIT_PREFILL_EMAIL_PARAM);
    params.delete(PARTNER_COCKPIT_PREFILL_EMAIL_PARAM);
    const searchStr = params.toString();
    return {
        target: `${location.pathname}${searchStr ? `?${searchStr}` : ''}${location.hash ?? ''}`,
        prefillEmail: candidate && isValidEmail(candidate) ? candidate : undefined,
        present,
    };
}
